module.exports = __webpack_public_path__ + "static/media/cloud-c2-v3.9d2f10b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cloud-c2-v3.svg
// module id = 98
// module chunks = 0